import { Injectable, TransferState, makeStateKey } from '@angular/core';
import { Store } from './store';

@Injectable()
export class ServerStoreService<T> extends Store<T> {
  id: string;
  isComplete = false;
  constructor(private transferState: TransferState) {
    super();
  }

  init(id: string) {
    this.id = id;
    const value = this.transferState.get(makeStateKey<T>(id), null);
    super.initialize(value);
    super.setState(value);
  }

  setContent(content: T) {
    if (this.isComplete) {
      this.transferState.set(makeStateKey<T>(this.id), content);
    }
    super.setState(content);
  }

  setCompleteState(isComplete: boolean) {
    this.isComplete = isComplete;
  }
}
